<script lang="ts">
    import { toast } from '../lib/stores/toast.svelte';
</script>

<div class="toasts">
    {#each toast.items as t (t.id)}
        <!--  -->
        <!-- svelte-ignore a11y_no_static_element_interactions,  a11y_click_events_have_key_events, a11y_no_noninteractive_element_interactions -->
        <div
                class="toast {t.type}"
                role="alert"
                onclick={() => toast.dismiss(t.id)}
        >
            {t.message}
        </div>
    {/each}
</div>

<style>
    .toasts {
        position: fixed; top: 16px; right: 16px;
        display: flex; flex-direction: column; gap: 8px;
        z-index: 9999;
    }
    .toast {
        padding: 12px 16px; border-radius: var(--radius);
        box-shadow: var(--shadow);
        cursor: pointer; min-width: 240px; max-width: 400px;
        font-size: 13px;
        animation: slide-in 0.2s ease-out;
    }
    .toast.success { background: var(--success); color: white; }
    .toast.error   { background: var(--danger);  color: white; }
    .toast.info    { background: var(--accent);  color: white; }
    @keyframes slide-in {
        from { transform: translateX(100%); opacity: 0; }
        to   { transform: translateX(0); opacity: 1; }
    }
</style>